// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gP","advertCardNum":"c-a_gQ"};